
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';


const EditHigherEducation = () => {
    const navigate = useNavigate();
    const [profileImage, setProfileImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const initialValues = {
        "વિદ્યાર્થીનું_નામ": '',
        "તારીખ": '',
        "ઉંમર": '',
        "પિતાનું_નામ": '',
        "ગામ": '',
        "તાલુકો": '',
        "રહેઠાણનું_હાલનું_સરનામું": '',
        "જિલ્લો": '',
        "વિદ્યાર્થીનો_ફોન_નં.": '',
        "પિતાનો_ફોન_નં.": '',
        "મકાન": '',
        "જમીન": '',
        "પિતાનો_વ્યવસાય": '',
        "વ્યવસાય_નું_સરનામું": '',
        "શિક્ષણ_સહાય": '',
        "અભ્યાસક્રમનું_આખું_નામ": '',
        "સ્કૂલ_કોલેજ_નું_નામ": '',
        "સ્કૂલ_કોલેજનું_સરનામું": '',
        "વાર્ષિક_ફી_ની_વિગત": '',
        "અભ્યાસક્રમનો_સમયગાળો": '',
        "સંસ્થાનું_નામ": '',
        "સહાય_કરેલ_રકમ": '',
    };

    const validationSchema = Yup.object({
        // વિધવા_દીકરીનું_નામ: Yup.string().required('Required'),
        // તારીખ: Yup.string().required('Required'),
        // સભ્યના_પિતા_નું_નામ: Yup.string().required('Required'),
        // માધ્યમ: Yup.string().required('Required'),
        // સભ્યનું_ભણતર: Yup.string().required('Required'),
        // ટકાવારી: Yup.string().required('Required'),
        // મેળવેલ_ગુણ: Yup.string().required('Required'),
    });
    const acceptRequest = () => {
        console.log('Accept Request');
    }
    const rejectRequest = () => {
        console.log('Reject Request');
    }
    return (
        <>
            <div className=" bg-gray-50 pb-0">
                <div className=" mx-aut0">
                    <div className="bg-white rounded-lg shadow p-6 lg:p-9">
                        <div className="py-2 lg:py-4">
                            <button
                                onClick={() => navigate(-1)}
                                className="flex flex-wrap items-center text-gray_2"
                            >
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                Back
                            </button>
                        </div>
                        <div className="flex flex-wrap justify-between items-center pb-6 xl:space-y-0 space-y-3">
                            <div className="flex items-center space-x-4">
                                <div className="h-12 lg:h-16 w-12 lg:w-16 rounded-full bg-gray-200 flex items-center justify-center text-xs text-gray-500 border border-gray-300">
                                    No Image
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-16 lg:text-24 font-semibold text-text_1">
                                        Emilia Isobel Euphemia Rose Clarke
                                        <span className="text-14 text-green bg-[#E7FAF0] rounded-lg py-1 lg:py-2 px-2.5 lg:px-4 ml-5">Active</span>
                                    </h2>
                                    <span className="block text-sm text-gray-500">+91 9632597041</span>
                                </div>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={() => { acceptRequest() }}
                                    className="btn"
                                >
                                    Accept
                                </button>
                                <button
                                    onClick={() => { rejectRequest() }}
                                    className="px-4 py-2 bg-red hover:bg-white hover:text-red border hover:border-red text-white font-medium rounded-md anim"
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                        <div className="space-y-7 md:space-y-9">
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                            >
                                {({ isSubmitting, setFieldValue }) => (
                                    <Form className='pt-3 lg:pt-6 space-y-7 md:space-y-9'>
                                        <div className="shadow-custom_shadow rounded-[20px] p-9">
                                            <h2 className="text-18 font-semibold text-gray_2 border-b border-gray_2 pb-6">Details of higher education assistance
                                                <span className="text-14 text-green bg-[#E7FAF0] rounded-lg py-2 px-4 ml-5">Active</span>
                                            </h2>
                                            <div className="flex flex-wrap -mx-3 pt-6">
                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        વિદ્યાર્થીનું નામ
                                                    </label>
                                                    <Field
                                                        name="વિદ્યાર્થીનું_નામ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='વિદ્યાર્થીનું નામ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનુ_અટક" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>

                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        તારીખ
                                                    </label>
                                                    <Field
                                                        type="date"
                                                        name="તારીખ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='તારીખ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        ઉંમર
                                                    </label>
                                                    <Field
                                                        type="date"
                                                        name="ઉંમર"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='ઉંમર'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>

                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        પિતાનું નામ
                                                    </label>
                                                    <Field
                                                        name="પિતાનું_નામ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='પિતાનું નામ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યના_પિતા_નું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                        ગામ
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="ગામ"
                                                        className="w-full p-2 border border-gray-300 rounded-md"
                                                        placeholder='ગામ'
                                                    >
                                                        <option value="">ગામ</option>
                                                        <option value="ગામ">ગામ</option>
                                                        <option value="ગામ">ગામ</option>
                                                        <option value="ગામ">ગામ</option>
                                                    </Field>
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                        તાલુકો
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="તાલુકો"
                                                        className="w-full p-2 border border-gray-300 rounded-md"
                                                        placeholder='તાલુકો'
                                                    >
                                                        <option value="">તાલુકો</option>
                                                        <option value="તાલુકો">તાલુકો</option>
                                                        <option value="તાલુકો">તાલુકો</option>
                                                        <option value="તાલુકો">તાલુકો</option>
                                                    </Field>
                                                </div>
                                                <div className="w-full px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        રહેઠાણનું હાલનું સરનામું
                                                    </label>
                                                    <Field
                                                        name="રહેઠાણનુ_હાલનું_સરનામું"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="રહેઠાણનું હાલનું સરનામું"
                                                    />
                                                    {/* <ErrorMessage name="ટકાવારી" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                        જિલ્લો
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        name="જિલ્લો"
                                                        className="w-full p-2 border border-gray-300 rounded-md"
                                                        placeholder='જિલ્લો'
                                                    >
                                                        <option value="">જિલ્લો</option>
                                                        <option value="જિલ્લો">જિલ્લો</option>
                                                        <option value="જિલ્લો">જિલ્લો</option>
                                                        <option value="જિલ્લો">જિલ્લો</option>
                                                    </Field>
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                        વિદ્યાર્થીનો ફોન નં.
                                                    </label>
                                                    <div className='flag_drop input_phone'>
                                                        <PhoneInput
                                                            country={'in'}
                                                            value=""
                                                            onChange={phone => setFieldValue('વિદ્યાર્થીનો_ફોન_નં.', phone)}
                                                            inputClass="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                            placeholder='વિદ્યાર્થીનો ફોન નં.'
                                                        />
                                                    </div>
                                                    {/* <ErrorMessage name="વિદ્યાર્થીનો_ફોન_નં." component="div" className="text-red text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                                        પિતાનો ફોન નં.
                                                    </label>
                                                    <div className='flag_drop input_phone'>
                                                        <PhoneInput
                                                            country={'in'}
                                                            value=""
                                                            onChange={phone => setFieldValue('વિદ્યાર્થીનો_ફોન_નં.', phone)}
                                                            inputClass="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                            placeholder='પિતાનો ફોન નં.'
                                                        />
                                                    </div>
                                                    {/* <ErrorMessage name="વિદ્યાર્થીનો_ફોન_નં." component="div" className="text-red text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        મકાન(પોતાનું/ભાડાનું)?
                                                    </label>
                                                    <Field
                                                        name="મકાન "
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="મકાન(પોતાનું/ભાડાનું)? "
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનું_ભણતર" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        જમીન
                                                    </label>
                                                    <Field
                                                        name="જમીન"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="જમીન"
                                                    />
                                                    {/* <ErrorMessage name="જમીન" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>

                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        પિતાનો વ્યવસાય
                                                    </label>
                                                    <Field
                                                        name="પિતાનો_વ્યવસાય"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="પિતાનો વ્યવસાય"
                                                    />
                                                    {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-4/6 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        વ્યવસાય નું સરનામું
                                                    </label>
                                                    <Field
                                                        name="વ્યવસાય_નું_સરનામું"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="વ્યવસાય નું સરનામું"
                                                    />
                                                    {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        ધોરણ-12 (કોમર્સ કે સાયન્સમાં આવેલ ટકાવારી)
                                                    </label>
                                                    <Field
                                                        name="કોમર્સ_કે_સાયન્સમાં_આવેલ_ટકાવારી"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="60%"
                                                    />
                                                    {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shadow-custom_shadow rounded-[20px] p-9">
                                            <h2 className="text-18 font-semibold text-gray_2 border-b border-gray_2 pb-6">Education assistance details
                                            </h2>

                                            <div className="flex flex-wrap -mx-3 pt-6">
                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        શિક્ષણ સહાય
                                                    </label>
                                                    <Field
                                                        name="શિક્ષણ_સહાય"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='શિક્ષણ સહાય'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનુ_અટક" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>

                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        અભ્યાસક્રમનું આખું નામ
                                                    </label>
                                                    <Field
                                                        name="અભ્યાસક્રમનું_આખું_નામ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='અભ્યાસક્રમનું આખું નામ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        કોલેજ નું નામ
                                                    </label>
                                                    <Field
                                                        name="કોલેજ_નું_નામ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='કોલેજ નું નામ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        કોલેજનું સરનામું
                                                    </label>
                                                    <Field
                                                        name="કોલેજનું_સરનામું"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="કોલેજનું સરનામું"
                                                    />
                                                    {/* <ErrorMessage name="ટકાવારી" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        વાર્ષિક ફી ની વિગત
                                                    </label>
                                                    <Field
                                                        name="વાર્ષિક_ફી_ની_વિગત"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="વાર્ષિક ફી ની વિગત"
                                                    />
                                                    {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                                <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        અભ્યાસક્રમનો સમયગાળો
                                                    </label>
                                                    <Field
                                                        name="અભ્યાસક્રમનો_સમયગાળો"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="અભ્યાસક્રમનો સમયગાળો"
                                                    />
                                                    {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shadow-custom_shadow rounded-[20px] p-9">
                                            <h2 className="text-18 font-semibold text-gray_2 border-b border-gray_2 pb-6">Details of scholarships available from other institutions
                                            </h2>
                                            <div className="flex flex-wrap -mx-3 pt-6">
                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        સંસ્થાનું નામ
                                                    </label>
                                                    <Field
                                                        name="સંસ્થાનું_નામ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='સંસ્થાનું નામ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનુ_અટક" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>

                                                <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                    <label className="block text-sm font-medium text-text_1 mb-1">
                                                        સહાય કરેલ રકમ
                                                    </label>
                                                    <Field
                                                        name="સહાય_કરેલ_રકમ"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='સહાય કરેલ રકમ'
                                                    />
                                                    {/* <ErrorMessage name="સભ્યનું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default EditHigherEducation;